import { FormEvent, useContext, useState } from "react";
import { Button, Loader } from "../Styles";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { toast } from "react-toastify";
import { paramsIndicadoresLista } from "../../interfaces/bancoIndicador";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { atualizarIndicador, cadastrarIndicador } from "../../services/bancoIndicadores";
import { criptografarDado, descriptografarDado } from "../../helpers";

function ModalIndicador({ indicador }: paramsIndicadoresLista) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

  const [processando, setProcessando] = useState(false);

  const [titulo, setTitulo] = useState<string>(indicador?.titulo || "");
  const [descricao, setDescricao] = useState<string>(indicador?.descricao || "");
  const [situacao, setSituacao] = useState(indicador?.situacao);
  const [grupo, setGrupo] = useState(indicador?.grupo || "");
  const [sigla, setSigla] = useState(indicador?.sigla || "");
  const [insight, setInsight] = useState(indicador?.insight || "");
  const [tipoGrafico, setTipoGrafico] = useState(indicador?.tipoGrafico || "");
  const [metodologia, setMetodologia] = useState(indicador?.metodologia || "");

  const ocultarModal = () => modalExibir('')
  
  const [tipo, setTipo] = useState(indicador?.indicadoresTarefas[0]?.tipo || "");
  const [prioridade, setPrioridade] = useState(indicador?.indicadoresTarefas[0]?.prioridade || "");
  const [descricaoTarefa, setDescricaoTarefa] = useState(indicador?.indicadoresTarefas[0]?.descricao || "");
  const [prazo, setPrazo] = useState<number>(indicador?.indicadoresTarefas[0]?.prazo || 0);
  const [recorrencia, setRecorrencia] = useState(indicador?.indicadoresTarefas[0]?.recorrencia || "");

  const handleSubmitIndicador = async (e: FormEvent) => {
    e.preventDefault()
    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
    const permissoesAutorizadas = ['master', 'administrativo', 'projeto_banco_indicadores']
    const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

    if(!temPermissao) return toast.warn("Você não tem permissão para cadastrar novos indicadores.")
    setProcessando(true)
    try {
      const payload = {
        titulo,
        grupo,
        sigla,
        descricao,
        metodologia,
        insight,
        tipoGrafico,
        tipo,
        prioridade,
        descricaoTarefa,
        prazo,
        recorrencia,
      }

      if (tipo === "" || prioridade === "" || recorrencia === "" || descricaoTarefa === "") {
        setProcessando(false)
        return toast.warn("Os dados da tarefa vinculada precisam ser preenchidas.")
      }

      const resposta = await cadastrarIndicador(payload)

      if (resposta.status === 201) {
        setProcessando(false)
        atualizarDados()
        modalExibir("")
        return toast.success("Indicador Cadastrado com Sucesso.")
      }
    } catch (error) {
      toast.error("Erro ao Cadastrar Indicador")
    }
  }

  const handleUpdateIndicador = async (e: FormEvent) => {
    e.preventDefault()
    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
    const permissoesAutorizadas = ['master', 'administrativo', 'projeto_banco_indicadores']
    const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

    if(!temPermissao) return toast.warn("Você não tem permissão para atualizar os indicadores.")
    setProcessando(true)

    if (!indicador) return toast.error("Indicador não encontrado.")
    const idTarefaCript = criptografarDado(indicador.indicadoresTarefas[0].id.toString())
    const idIndicadorCript = criptografarDado(indicador.id.toString())
    try {
      const payload = {
        titulo,
        grupo,
        sigla,
        descricao,
        metodologia,
        insight,
        tipoGrafico,
        situacao,
        tipo,
        prioridade,
        descricaoTarefa,
        prazo,
        recorrencia,
      }

      const resposta = await atualizarIndicador(idIndicadorCript, idTarefaCript, payload)

      if (resposta.status === 200) {
        setProcessando(false)
        atualizarDados()
        modalExibir("")
        return toast.success("Indicador Atualizado com Sucesso.")
      }
    } catch (error: any) {
      if (error.response.status === 404) {
        setProcessando(false)
        modalExibir("")
        return toast.warn("Indicador não encontrado.")
      }
      return toast.error("Erro ao Atualizar Indicador")
    }
  }

  return (
    <div className="fundoModal">
      <section className='containerModalCentro'>
        <span id='novoContainerTitulo'>
          <BsFileEarmarkBarGraph className='adicionarModalIcone' title="Icone Indicador" />
          <p>{!indicador ? 'Novo Indicador' : 'Vizualizar Indicador'}</p>
        </span>
        <form id='formModalNovo' onSubmit={indicador ? handleUpdateIndicador : handleSubmitIndicador}>
          <section>
            <span>
              <label>Título</label>
              <input type="text" placeholder="Titulo do Indicador" onChange={(e) => setTitulo(e.target.value)} required={!indicador} defaultValue={titulo} maxLength={100} />
            </span>
            <span>
              <label>Sigla</label>
              <input type="text" placeholder="Sigla do Indicador" onChange={(e) => setSigla(e.target.value)} required={!indicador} defaultValue={sigla} maxLength={50} />
            </span>
          </section>
          <section>
            {!indicador &&
              <span>
                <label>Grupo</label>
                <select onChange={(e) => setGrupo(e.target.value)} required={!indicador} defaultValue={grupo}>
                  <option value="" disabled>Selecione o Grupo</option>
                  <option value="Gestão Financeira" >Gestão Financeira</option>
                  <option value="Gestão de Pessoas" >Gestão de Pessoas</option>
                  <option value="Desenvolvimento de Software" >Desenvolvimento de Software</option>
                  <option value="Outros">Outros</option>
                </select>
              </span>
            }
          </section>
          <section>
            {indicador &&
              <span>
                <label>Situação</label>
                <select onChange={(e) => setSituacao(e.target.value)} required={!!indicador} defaultValue={situacao}>
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                </select>
              </span>
            }
          </section>
          <section>
            <span>
              <label>Tipo do Grafico</label>
              <select onChange={(e) => setTipoGrafico(e.target.value)} required={!indicador} defaultValue={tipoGrafico}>
                <option value="" disabled>Selecione o tipo do Grafico</option>
                <option value="Card">Card</option>
                <option value="Colunas">Colunas</option>
                <option value="Linhas">Linhas</option>
                <option value="Pizza">Pizza</option>
                <option value="Barras">Barras</option>
              </select>
            </span>
          </section>
          {tipoGrafico === "Card" && <section>
            <span>
              <label>Insight</label>
              <textarea className="textAreaModal" rows={5} placeholder="Mensagem para colocar no Card" onChange={(e) => setInsight(e.target.value)} defaultValue={insight} maxLength={100}></textarea>
            </span>
          </section>}
          <section>
            <span>
              <label>Descrição</label>
              <textarea className="textAreaModal" rows={5} placeholder="Descrição do Indicador" onChange={(e) => setDescricao(e.target.value)} defaultValue={descricao} maxLength={500} required={!indicador}></textarea>
            </span>
          </section>
          <section>
            <span>
              <label>Metodologia</label>
              <textarea className="textAreaModal" rows={5} placeholder="Metodologia do Indicador" onChange={(e) => setMetodologia(e.target.value)} defaultValue={metodologia} maxLength={500} required={!indicador}></textarea>
            </span>
          </section>
          <section>
            <span>
              <details className="details-container-tags">
                <summary>
                  Tarefa Vinculada
                </summary>
                <section>
                  <span>
                    <label>Tipo</label>
                    <select onChange={(e) => setTipo(e.target.value)} defaultValue={tipo}>
                      <option value="" disabled>Selecione o tipo</option>
                      <option value="tarefa">Tarefa</option>
                      <option value="atendimento">Atendimento</option>
                      <option value="chamado">Chamado</option>
                    </select>
                  </span>
                  <span>
                    <label>Prioridade</label>
                    <select onChange={(e) => setPrioridade(e.target.value)} defaultValue={prioridade}>
                      <option value="" disabled>Selecione a prioridade</option>
                      <option value="urgente">Urgente</option>
                      <option value="alta">Alta</option>
                      <option value="baixa">Baixa</option>
                    </select>
                  </span>

                </section>
                <section>
                  <span>
                    <label>Prazo</label>
                    <input type="number" onChange={(e) => { setPrazo(parseInt(e.target.value)) }} placeholder="Prazo" defaultValue={prazo} required />
                  </span>
                  <span>
                    <label>Recorrencia</label>
                    <select onChange={(e) => setRecorrencia(e.target.value)} defaultValue={recorrencia}>
                      <option value="" disabled>Selecione a Recorrencia</option>
                      <option value="diaria">Diaria</option>
                      <option value="semanal">Semanal</option>
                      <option value="mensal">Mensal</option>
                      <option value="trimestral">Trimestral</option>
                      <option value="semestral">Semestral</option>
                      <option value="anual">Anual</option>
                    </select>
                  </span>
                </section>
                <section>
                  <span>
                    <label>Descrição da Tarefa</label>
                    <textarea className="textAreaModal" rows={5} placeholder="Descrição da Tarefa" onChange={(e) => setDescricaoTarefa(e.target.value)} defaultValue={descricaoTarefa}></textarea>
                  </span>
                </section>
              </details>
            </span>
          </section>
          <span id="botoesContainer">
            <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
              {!processando && !indicador && 'Cadastrar'}
              {!processando && indicador && 'Atualizar'}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
    </div>
  )
}

export default ModalIndicador